import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../../features/webStorageSaver";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { MapTooltip } from "../../../../widgets/map/mapAddons/mapTooltip";
import { getBasicObjectTypeLayer, getAllRoadObjectsLayer } from "../../../../widgets/map/mapFeatures/layers";
import { showMapTooltip } from "../../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import MapWidget from "../../../../widgets/map/mapWidget/MapWidget";
import { useDispatch } from "react-redux";
import { setMapTooltipIsVisible } from "../../../../stateManagement/reducers/MapTooltipSlice";
import { getObjectsOnMapPoint } from "../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import TableUnderMap from "../../../tables/tableUnderMap/TableUnderMap";
import { LastYearsMapFilter } from "../../../lastYearsMapFilter";
import { falseTableFilterExpression } from "../../../../widgets/table/tableFeatures/tableFunctions";
import ContentHeader from "../../../../widgets/contentHeader/ContentHeader";

export function MapRoadWorkSegmentsPODD() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapName = "RoadWorkSegmentsPODD"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [isSmallWindow, setIsSmallWindow] = useState(true);
    const [tableUnderMapFilterString, setTableUnderMapFilterString] = useState<any>(null)
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const yearFilter = useAppSelector(state => state.mapFilters?.lastYearsMapFilters)?.[mapName] ?? {}
    const { wmsServer, wmsVersion, workspace, menuAdditionalItems } = getItemWebStorage('currentConfig')
    const menuItem = menuAdditionalItems.find((menuItem: any) => menuItem?.item?.type === `map.${mapName}`)?.item
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)

    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, mapStaticFilter, title } = menuItem
        title && setMapTitle(`Карта «${title}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let layerFilterArray = []
        if (mapStaticFilter) {
            layerFilterArray.push(mapStaticFilter)
        }
        const checkedYears = Object.entries(yearFilter).filter(([year, checked]: any) => checked).map(([year, checked]: any) => year)
        layerFilterArray.push(`EventYear in (${checkedYears.join(',')})`)
        let layerFilter = layerFilterArray.join(' and ')
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
    }, [yearFilter]);

    useEffect(() => {
        const { tableUnderMapStaticFilter } = menuItem
        let tableUnderMapFilterArray = []
        if (tableUnderMapStaticFilter) {
            tableUnderMapFilterArray.push(tableUnderMapStaticFilter)
        }
        const checkedYears = Object.entries(yearFilter).filter(([year, checked]: any) => checked).map(([year, checked]: any) => year)
        let tableUnderMapYearsFilterArray: any = []
        checkedYears.map((checkedYear: any) => {
            tableUnderMapYearsFilterArray.push(`EventYear eq ${checkedYear}`)
        })
        if (tableUnderMapYearsFilterArray.length > 0) {
            tableUnderMapFilterArray.push(`(${tableUnderMapYearsFilterArray.join(' or ')})`)
        } else {
            tableUnderMapFilterArray.push(falseTableFilterExpression)
        }
        let tableUnderMapFilterString = tableUnderMapFilterArray.join(' and ')
        setTableUnderMapFilterString(tableUnderMapFilterString)
    }, [yearFilter])

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 440);
    }, [sideBarState, navigate])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnMapPoint(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFindAlways",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" />
            <div className="map-widget-with-toast">
                {!isSmallWindow && <LastYearsMapFilter filterType="header" numberOfYears={4} objectType={mapName} />}
                <MapTooltip type={mapName} />
                <MapWidget
                    additionalLayers={additionalLayers}
                    mapEventHandlers={mapEventHandlers}
                    permanentLayers={permanentLayers}
                    mapSizeClass={tableUnderMapIsShown ? 'half-size-map-widget' : null}
                />
                {tableUnderMapIsShown &&
                    <TableUnderMap
                        objectType="RoadWorkSegments"
                        canBeFiltered={false}
                        filtersExpression={tableUnderMapFilterString}
                    />}
            </div>
        </>
    )
}
